import {Header} from "./components/Header";
import {Banner} from "./components/Banner";
import {Servicios} from "./components/Servicios";
import {Empresa} from "./components/Empresa";
import {Footer} from "./components/Footer";
import {Monitoreo} from "./components/Monitoreo";
import {Seguridad} from "./components/Seguridad";
import {GrupoPluss} from "./components/GrupoPluss";
import {NewClientesHome} from "./components/NewClientesHome";
import {Flotabuses} from "./components/Flotabuses";

function App() {
  return (
    <>
        <Header/>
        <Banner/>
        <Servicios/>
        <Empresa/>
        <Flotabuses/>
        <Seguridad/>
        <Monitoreo/>
        <NewClientesHome/>
        <GrupoPluss/>
        <Footer/>
    </>
  );
}

export default App;
